var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.736 26.162V44.75h-7.481V26.162H13v-7.244h6.255v-5.343C19.255 7.376 23.042 4 28.572 4c2.65 0 4.927.197 5.59.285v6.479l-3.836.002c-3.007 0-3.59 1.429-3.59 3.527v4.625h7.174l-.934 7.244h-6.24Z",
    fill: "#909495"
  })));
};
export default SvgFacebook;